export default __webpack_public_path__ + "static/media/Sharing_Location_cut.3526df9c.jpg";